import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

export const Notifications = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const unread = items.filter((n) => !n.read).length;

  useEffect(() => {
    let first = true;
    const load = () =>
      api.get("/notifications").then((r) => {
        setItems(r.data);
        const promo = r.data.find((n) => !n.read && n.kind === "promotion");
        if (first && promo) toast.success(promo.message);
        first = false;
      }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  const openSheet = () => {
    setOpen(true);
    if (unread) api.post("/notifications/read").then(() => setItems((it) => it.map((n) => ({ ...n, read: true }))));
  };

  return (
    <>
      <button data-testid="notifications-button" onClick={openSheet} className="relative w-10 h-10 rounded-full bg-white border border-slate-200 shadow-sm flex items-center justify-center active:scale-95 transition-transform">
        <Bell className="w-5 h-5 text-slate-600" />
        {unread > 0 && <span data-testid="notifications-unread" className="absolute -top-0.5 -right-0.5 min-w-5 h-5 px-1 rounded-full bg-pink-500 text-white text-[10px] font-bold flex items-center justify-center">{unread}</span>}
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="bg-[#F2F5FA] border-slate-200 text-slate-900 w-[88%] max-w-sm">
          <SheetHeader><SheetTitle className="text-slate-900 font-display text-left">Notifications</SheetTitle></SheetHeader>
          <div className="mt-6 space-y-2 overflow-y-auto max-h-[80vh]" data-testid="notifications-list">
            {items.length === 0 && <p className="text-sm text-slate-500">Aucune notification pour le moment.</p>}
            {items.map((n) => (
              <div key={n.id} className="rounded-2xl bg-white border border-slate-200 p-3">
                <p className="text-sm text-slate-800">{n.message}</p>
                <p className="text-[11px] text-slate-500 mt-1">{new Date(n.created_at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}</p>
              </div>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
